module.exports = __webpack_public_path__ + "media/assets/close-6841a50d.png";